export default "__VITE_ASSET__BDgi0Fyg__"